import React from 'react';

export const ApiErrorStep: React.FC = () => {
  return (
    <div className='w-full h-full min-h-[400px] flex flex-col items-center gap-16 px-16 sm:py-16'>
      <div className='flex flex-col gap-4'>
        <h2 className='text-2xl font-bold text-red-600'>
          We're experiencing technical difficulties
        </h2>
        <div>
          We're sorry, but we're currently unable to process your health questionnaire. This is a temporary technical issue on our end, not a problem with your application.
        </div>
        <div>
          <strong>What you can do:</strong>
          <ul className='list-disc list-inside space-y-2 mt-2'>
            <li>Please try again in a few minutes</li>
            <li>If the problem persists, please contact our support team</li>
            <li>Your information has been saved and you won't need to start over</li>
          </ul>
        </div>
        <div className='text-sm text-gray-600'>
          Error: Estimation service is unavailable. Please try again later.
        </div>
      </div>
    </div>
  );
};
